import LogoWithDropdowns from "./Navbar/LogoWithDropdowns";
import ProfileDropdown from "./Navbar/ProfileDropdown";
import Notification from "./Navbar/Notification";
import WithCancel from "./Navbar/WithCancel";
import WithBack from "./Navbar/WithBack";
import Index from "./Navbar/Index";

export default Object.assign(Index, {
  LogoWithDropdowns,
  ProfileDropdown,
  Notification,
  WithCancel,
  WithBack
});
